var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGstreporticon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24.004,
    height: 24,
    rx: 4,
    fill: "#34839C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#kbcjs4fgya)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16.85 8.65-3.5-3.5c-.1-.1-.2-.15-.35-.15H8c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h8c.55 0 1-.45 1-1V9c0-.15-.05-.25-.15-.35zM13 6.2 15.8 9H13V6.2zM16 18H8V6h4v3c0 .55.45 1 1 1h3v8z"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h5hq0bm7eb)",
    stroke: "#fff",
    strokeWidth: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.409 13.827a1.237 1.237 0 0 0 1.236-1.236 1.236 1.236 0 1 0-1.236 1.236zm-.323-1.72a.582.582 0 0 1 .323-.098v-.1.1a.583.583 0 1 1-.323.098zM14.476 11.384l-.07-.07-.071.07-5.133 5.133-.071.07.07.072.322.321.07.07.072-.07 5.133-5.133.07-.07-.07-.072-.322-.321zM13.59 17.009a1.238 1.238 0 0 0 1.237-1.236 1.237 1.237 0 1 0-1.236 1.236zm-.323-1.72a.582.582 0 0 1 .324-.098v-.1.1a.582.582 0 1 1-.324.098z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "kbcjs4fgya"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(4 4)",
    d: "M0 0h16v16H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h5hq0bm7eb"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(8.363 10.545)",
    d: "M0 0h7.273v7.273H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGstreporticon);
export default __webpack_public_path__ + "static/media/gstreporticon.2ecdbf23b92729ef3b3ca7e740194c69.svg";
export { ForwardRef as ReactComponent };